var _style, _path, _path2, _path3, _path4, _path5, _path6, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _rect, _rect2, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMyOpswat(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    style: {
      enableBackground: "new 0 0 202 71.9"
    },
    xmlSpace: "preserve",
    viewBox: "23.79 24.1 154.41 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26.6,35.9v-7.5c-1.9,2.1-2.9,4.7-2.8,7.5c-0.1,6.5,5.1,11.9,11.6,12c0.1,0,0.3,0,0.4,0c2.7,0,5.3-0.9,7.4-2.6  v-3.2c-1.9,2.1-4.6,3.3-7.5,3.3C30.6,45.4,26.6,41.3,26.6,35.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M35.8,24.1c-2.7,0-5.3,0.9-7.4,2.6v3.2c1.9-2.1,4.6-3.3,7.4-3.3c5,0,9.2,4.1,9.2,9.1c0,0.1,0,0.3,0,0.4v7.5  c1.9-2.1,2.9-4.7,2.8-7.5c0.1-6.5-5.1-11.9-11.6-12C36,24.1,35.9,24.1,35.8,24.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M63.9,24.5h-8.1v23.1h2.7V26.9h5.3c3,0,4.6,1.9,4.6,4.3s-1.6,4.3-4.6,4.3h-3.6v2.4h3.7c4.5,0,7.4-2.8,7.4-6.7  S68.4,24.5,63.9,24.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M90.8,29.5l2-1.5c-1.6-2.4-4.2-3.9-7.1-3.9c-0.9,0-1.7,0.1-2.5,0.4V27c0.8-0.3,1.6-0.5,2.4-0.5  C87.7,26.6,89.7,27.7,90.8,29.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M87.7,35.1l-2.6-1.2c-2.1-1-3.7-1.8-3.7-4.2v-4.3c-1.8,1-2.8,2.8-2.8,4.9c0,3.2,2.5,4.9,5.2,6.2l2.6,1.2  c2.3,1.1,3.8,1.9,3.8,4.4v4.7c1.8-1.1,2.9-3,2.8-5.1C93.1,38.4,91.1,36.7,87.7,35.1z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M79.2,41.5l-2,1.5c1.7,3.1,4.9,5,8.4,5c1,0,2-0.2,3-0.5v-2.6c-0.9,0.3-1.9,0.5-2.9,0.5  C82.6,45.4,80.6,43.6,79.2,41.5z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "98.4,24.5 107.2,48 108.1,48 109.1,45.6 101.4,24.5 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "124,39.7 125.5,43.3 132.5,24.5 129.5,24.5 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "114.9,24.1 108.8,39.6 110.1,43.2 115.4,29.7 122.7,48 123.8,48 124.6,45.7 115.9,24.1 "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "144.9,24.1 143.9,26.3 153,47.6 155.9,47.6 145.9,24.1 "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "140.8,40.5 144.4,31.9 143,28.5 134.9,47.6 137.8,47.6 139.7,42.9 149.2,42.9 148.1,40.5 "
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 165.5,
    y: 28.7,
    className: "st0",
    width: 2.7,
    height: 18.9
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 157.4,
    y: 24.5,
    className: "st0",
    width: 19,
    height: 2.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M176.4,44.4c-1,0-1.9,0.8-1.9,1.8c0,1,0.8,1.9,1.8,1.9c1,0,1.9-0.8,1.9-1.8c0,0,0,0,0,0  C178.2,45.2,177.4,44.4,176.4,44.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyOpswat);
export default __webpack_public_path__ + "static/media/MyOPSWAT.227d3c5afa16c0084db9c58f9b529ece.svg";
export { ForwardRef as ReactComponent };